$w.onReady(function () {
var dobms = $w('#dynamicDataset').getCurrentItem().age;
var nowms = Date.now();
var age = Math.floor((nowms - dobms) / (365.25 * 24 * 60 * 60 * 1000)); $w("#iAge").text = age.toString();
});

$w.onReady(function () {
	$w("#dynamicDataset").onReady(function () {
		const dob = $w('#iAge').text; 
		if (dob === 'NaN') {
			$w('#iAge').text = 'N/A'; 
		} 
	});
});

$w.onReady(function () {
	$w("#dynamicDataset").onReady(function () {
		const dob = $w('#iAge').text;
		if (dob === '48') {
			$w('#iAge').text = 'N/A';
		}
	});
});